export default {
  'Maximum balance': 'Maximum balance',
  'Purchase acceptance per day': 'Purchase acceptance per day',
  'Purchase acceptance per month': 'Purchase acceptance per month',
  'Payout daily': 'Payout daily',
  'Payout per month': 'Payout per month',
};
